import type { CSSProperties } from "react";
import { LINEAGES } from "../data/lineages";

interface LineageRailProps {
  current: string;
  onSelect: (lineage: string) => void;
}

export function LineageRail({ current, onSelect }: LineageRailProps) {
  return (
    <div className="lineage-rail" role="group" aria-label="Switch dragon lineage">
      <span className="lineage-rail__label">Lineage</span>
      <div className="lineage-rail__track">
        {LINEAGES.map((lineage) => (
          <button
            type="button"
            key={lineage.id}
            className={`lineage-chip ${current === lineage.id ? "is-active" : ""}`}
            style={{ "--chip": lineage.accent, "--chip-soft": lineage.accentSoft } as CSSProperties}
            aria-pressed={current === lineage.id}
            title={lineage.label}
            onClick={() => onSelect(lineage.id)}
          >
            <span className="lineage-chip__dot" aria-hidden="true" />
            <span className="lineage-chip__name">{lineage.label.replace(" Dragon", "")}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
